import { useState } from "react";

type Props = {
  label: string;
  type?: "text" | "email" | "tel" | "password";
  value: string;
  onChange: (v: string) => void;
  onBlur?: () => void;
  error?: string;
  autoComplete?: string;
};

export function Field({ label, type = "text", value, onChange, onBlur, error, autoComplete = "off" }: Props) {
  const [focus, setFocus] = useState(false);
  return (
    <label className={`fld ${focus ? "focus" : ""} ${error ? "err" : ""}`}>
      <span className="fld-label">
        {label}
        <i className="fld-req">*</i>
      </span>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setFocus(true)}
        onBlur={() => {
          setFocus(false);
          onBlur?.();
        }}
        autoComplete={autoComplete}
      />
      {error && <span className="fld-error">{error}</span>}
    </label>
  );
}
